import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const magazzinoRifiuti: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'descrizioneSoggetto - $descrizioneSede ',
      titleForm: 'descrizioneSoggetto - $descrizioneSede ',
      breadcrumbCaption: 'Magazzini rifiuti',
    
      allowedAdvancedFilter:false,
      isAdvancedXlsExportAvailable:false,
      campoTitle: ['descrizioneSoggetto', 'descrizioneSede', 'descrizione'],
      masterKey: 'id',
      service: 'magazzinorifiuti',
      startTemplate:'grid',
      api: 'magazzinorifiuti',
      filterList: '?idSede=$idSede',
      filterEditor: '/$',
      helpDoc: 'MagazziniRifiuti.html',
      queryFilter: [


        {
          key: 'idMagazzino',
          value: 'id'
        },

      ],
      idTabRif: [

        {
          key: 'idSede',
          value: 'idSede'
        },



      ],
      formType: 'simple',
      nCol: 2,
      toolbarSettings: {
        service: 'magazzino',




      }



    }
  },
  
  {
    itemType: "group",groupWidth:633, colGroup:4, groupDataField:'DatiMagazzino', caption: 'Dati Magazzino', colCount: "2",
    data: [
       
      {
        orderGriglia:1,
        type: 'campo', 
        maxLength: "45", 
        maxSize: 45, 
        dataField: "descrizione", 
        caption: "Descrizione",
        nCol:10,
        showInColumnChooser:true,
        allowHiding:false,
        colWidth: '318',
        validation: [
          {
            type: 'required',
            message: 'Descrizone obbligatoria'
          }
        ]
      },

      {type: 'empty',dataField: '',nCol:6},

      {
        orderGriglia:2,
        showInColumnChooser:true,allowHiding:false,
        type: 'campo', editorType: 'dxNumberBox', 
        maxLength: "9", dataField: "maxGiacenza",
        caption: "Max giacenza ist.(Tn)", format: '####0.###', class: 'hideHelp',
        colWidth: '170',
        width:36.8,
        nCol:5,
        
      },

      {
        orderGriglia:3,
        colVisible:true,
        type: 'campo', editorType: 'dxNumberBox', maxLength: "9",
        dataField: "preavvisoGiacenza", format: '####0.###', class: 'hideHelp',
        colWidth: '175',
        nCol:5,
        width:36.8,
        labelWidth:185,
        caption: "Preav.max Giacenza ist.(Tn)",
       
      },

      { 
        orderGriglia:4,
        showInColumnChooser:true,allowHiding:false,
        type: 'campo', editorType: 'dxNumberBox', maxLength: "3", maxSize: 3, dataField: "maxGiorniGiacenza",
        caption: "Tempo max(Giorni)", class: 'hideHelp', format: '####0.###',
        colWidth: '216',
        width:36.8,
        nCol:5,
       
      },

      {orderGriglia:5,colVisible:true,
        type: 'campo', editorType: 'dxNumberBox',  maxLength: "3", maxSize: 3, dataField: "giorniPreavviso",
        caption: "Preav.max(Giorni)", class: 'hideHelp', format: '####0.###',
        colWidth: '190',
        nCol:5,
        width:36.8,
        labelWidth:185,
        
      },

      {orderGriglia:6,colVisible:true,
        showInColumnChooser:true,allowHiding:false,
        type: 'campo', editorType: 'dxNumberBox',  maxLength: "9", dataField: "maxCaricoAnno",
        caption: "Max Carico annuo(Tn)", format: '####0.###', class: 'hideHelp',
        colWidth: '190',
        nCol:5,
        width:36.8,
      
      },

      {orderGriglia:7,colVisible:true,
        type: 'campo', editorType: 'dxNumberBox', format: '####0.###',  maxLength: "9", dataField: "preavvisoCaricoAnno",
        caption: "Preav.max carico annuo(Tn)", class: 'hideHelp',
        colWidth: '210',labelWidth:185,
        nCol:5,
        width:36.8,
      },
      
      { orderGriglia:8,colVisible:true,
        colSpan:2,
        nCol:5,
        type: 'campo', dataField: 'isMagazzinoPredefinito', caption: 'Magaz.predefinito', dataType: "boolean",
        colWidth: '190',
        editorType: 'dxCheckBox',
        trueText: 'Si',
        falseText: 'No',
        showEditorAlways:false
      },
    ]
  },


  {
    itemType: "group", colGroup:6, groupDataField:'CerMagazzino', caption: 'Valori massimi dettagliati per E.E.R. e stato Fisico ', colCount: "2", class: "col-12 ",

    data: [


      {
        showInColumnChooser:false,
        type: 'campoSpecial', dataField: 'avverti', editorType: 'dxSelectBox',
        class: 'campo-desc-movimento', 
        caption: "Qualora questo magazzino venga utilizzato per E.E.R., RIFERIMENTO, STATO FISICO non presenti nella lista",
        labelPosition: 'left',
        labelWidth:688,
        colVisible: false,
        colSpan:2,
       
        lista: {
          dataSource: '',
          displayExpr: 'descrizione',
          valueExpr: 'id',
          static: true,
          showDropDownButton:true,
          items: [
            
            { id: true, descrizione: 'Avvertire' },
            { id: false, descrizione: 'Bloccare' }
          ]
        }
      },

      {
        type: 'campoDesc', dataField: 'infoMagazzino2',
        class: 'campo-desc-movimento-2',
        defaultValue: "Qualora lo STATO FISICO non venga specificato significa qualsiasi STATO FISICO, qualora il RIFERIMENTO non venga specificato significa qualsiasi RIFERIMENTO",
        labelVisible: false,
        colVisible: false,
        colSpan:2,
    
      },


      {
        showInColumnChooser:false,
        type: 'campoGriglia', labelVisible: false, 
        dataField: 'magazzinoRifiutiCer',
        nCol:10,
        colVisible: false,
        colSpan:2,
        formGrid: {
          service: 'magazzinorifiuticer',
          api: '',
          remoteOperation: false,
          queryString: '',
          isEditable: true,
          isEditableNewRow: true,
          isEditableEditRow: true,
          isEditableDeleteRow: true,
          
          showToolbarTop:true,
          tableHeight: 390,
          tableWidth:970,
          showFilter:false,

          selectionRowMode: null,  // 'single' | 'detail' | 'multiple';
          idTable: 'magazzinorifiuticer',
          isSearchable: false


      }

        


      },

    ]

  },




]